module.exports = __webpack_public_path__ + "static/downloads-3c59a08f8df1ce26148cde23a806cd59.png";